import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import logoPure from '../components/Logo2025.png';
import fundoPure from '../components/img3.jpg';

import imgVelasPure from '../components/HomebtnVelas.jpg';
import imgWaxPure from '../components/HomebtnWax2.jpg';

const Home = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (

    <div className="min-h-screen bg-gradient-to-br from-[#f5e1ce] to-[#F4DCC6]">
      <Header />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-pure_fundo"></div>
        
        {/* Hero Background Image */}
        <div className="absolute inset-0 opacity-80">
          <img 
            src={fundoPure}
            alt="Luxury candles" 
            className="w-full h-full object-cover"
          />
        </div>

        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">

          {/* Logo */}
          <div className="block mx-auto w-48 h-auto">
              <img src={logoPure} />
          </div>

          {/* Main Headlines */}  
          <p className="text-xl text-pure_titulo mb-8 font-light leading-relaxed font-lora">
            A Pure é feita de Amor... <br/> o Amor não se vê, mas sente-se 
          </p>

          {/* CTA Buttons */}
          {/*
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link 
              to="/candles"
              className="bg-pure_btn1 text-pure_btn1_txt px-8 py-4 rounded-full text-lg transition-all duration-300 hover:scale-105 shadow-lg font-lora">
              Velas
            </Link>
            <Link 
              to="/wax-melts"
              className="bg-pure_btn1 text-pure_btn1_txt px-8 py-4 rounded-full text-lg transition-all duration-300 hover:scale-105 shadow-lg backdrop-blur-sm font-lora">
              Wax Melts
            </Link>
          </div>
          */}
        </div>

        {/* Decorative Elements */}
        {/*
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <svg className="w-6 h-6 text-[#8B4513] opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
        */}

      </section>

      {/* Features Section */}
      <section className="py-24 bg-pure_fundo">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-lora font-light text-5xl mb-8 text-pure_titulo">
              Porquê escolher a Pure?
            </h2>
            <p className="text-xl text-pure_btn1_txt max-w-3xl mx-auto leading-relaxed font-montserrat">
              Cada peça das nossas coleções é cuidadosamente feita à mão com materiais premium e atenção a todos os detalhes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Feature 1 */}
            <div className="text-center group hover:scale-105 transition-transform duration-300">
              <div className="w-20 h-20 bg-pure_btn1 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-pure_symbol" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-2xl text-pure_titulo mb-4 font-lora">
                Feito à mão com Amor
              </h3>
              <p className="text-pure_btn1_txt leading-relaxed font-montserrat">
                Cada vela é individualmente criada à mão, assegurando exclusividade e qualidade em cada peça
              </p>
            </div>

            {/* Feature 2 */}
            <div className="text-center group hover:scale-105 transition-transform duration-300">
              <div className="w-20 h-20 bg-pure_btn1 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-pure_symbol" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-2xl text-pure_titulo mb-4 font-lora">
                Ingredientes Premium
              </h3>
              <p className="text-pure_btn1_txt leading-relaxed font-montserrat">
                Usamos apenas ceras 100% naturais (origem vegetal) e fragrâncias cuidadosamente selecionadas para criar ambientes acolhedores
              </p>
            </div>

            {/* Feature 3 */}
            <div className="text-center group hover:scale-105 transition-transform duration-300">
              <div className="w-20 h-20 bg-pure_btn1 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-pure_symbol" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl text-pure_titulo mb-4 font-lora">
                Sustentável
              </h3>
              <p className="text-pure_btn1_txt leading-relaxed font-montserrat">
                Em cada produto colocamos um forte compromisso de responsabilidade ambiental, desde as matérias-primas à embalagem
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Collections Preview */}
      <section className="py-24 relative bg-pure_fundo">

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center mb-16">
            <h2 className="font-lora font-light text-5xl mb-8 text-pure_titulo">
              Produtos
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Candles Collection */}
            <Link 
              to="/candles"
              className="group relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105"
            >
              <div className="aspect-w-16 aspect-h-12 relative">
                <img 
                  src={imgVelasPure}
                  alt="Candles collection"
                  className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-pure_fundo opacity-80"></div>
                
                <div className="absolute inset-0 p-12 flex flex-col justify-center items-center text-center">
                  <h3 className="text-3xl font-lora text-pure_titulo mb-4">
                    Velas
                  </h3>
                  <p className="text-pure_btn1_txt font-montserrat leading-relaxed mb-6">
                    Torna a tua casa mais acolhedora
                  </p>
                </div>
              </div>
            </Link>

            {/* Wax Melts Collection */}
            <Link 
              to="/wax-melts"
              className="group relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105"
            >
              <div className="aspect-w-16 aspect-h-12 relative">
                <img 
                  src={imgWaxPure}
                  alt="Wax melts collection"
                  className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-pure_fundo opacity-80"></div>
                
                <div className="absolute inset-0 p-12 flex flex-col justify-center items-center text-center">
                  <h3 className="text-3xl font-lora text-pure_titulo mb-4">
                    Wax Melts
                  </h3>
                  <p className="text-pure_btn1_txt font-montserrat leading-relaxed mb-6">
                    Com pouco tempo para relaxar?
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;